

export const alliances = [
    { id: "0", name: "Any airline", airlines: [] },
    {
        id: "1", name: "Oneworld", airlines: ["AA", "AB", "AY", "BA", "CX", "HG", "IB", "JJ", "KA", "LA", "LP",
            "QF", "JC", "JL", "MH", "MJ", "NU", "QR", "RJ", "S7", "UL", "US", "XL", "4M"]
    },
    { id: "2", name: "SkyTeam", airlines: ["AF", "AM", "AR", "AZ", "CI", "DL", "GA", "KE", "KL", "KQ", "ME", "MF", "MU", "OK", "DL", "KE", "KL", "KQ", "ME", "MF", "MU", "OK", "RO", "SU", "SV", "UX", "VN"] },
    { id: "3", name: "Star Alliance", airlines: ["A3", "AC", "AI", "AV", "BR", "CA", "CM", "ET", "JP", "LH", "LO", "LX", "MS", "NH", "NZ", "O6", "OS", "OU", "OZ", "SA", "SK", "SN", "SQ", "TG", "TK", "TP", "UA", "ZH"] }
];

export const currencyList = [
    "USD", "CAD", "AUD", "INR", "EUR", "GBP", "NZD", "MYR", "SGD", "THB", "JPY"
];

export const airplaneDown = 'assets/img/icons/airplane-dow.svg';
export const airplaneUp = 'assets/img/icons/airplane-up.svg';

export const passengerTypes = {
    A: 'Adult', C: 'Child', I: 'Infant'
};


export class solutionTypes {
    static readonly bestValue = 5;
    static readonly customize = 4;
    static readonly fewestStops = 3;
    static readonly bestTime = 2;
    static readonly bestPrice = 1;
};

export const BAGGAGE_FEE_PER_FLIGHT = 25;

export class INDIE_CONSTANTS {
  static readonly CREDIT_URL_QUERY_PARAM_NAME: string = "cdt";
  static readonly CREDIT_STRING_COOKIE_KEY = "cdt_str";
}

export const AFFILIATE_COOKIE_NAME = 'bna_indie_affid';
export const FULL_BASE_URL = location.protocol + '//' + location.hostname;
